module.exports = __webpack_public_path__ + "img/安全稳定.54159d98.png";